import { wrapSmartrrSnippet, DelimiterNames } from "./utils";

export const SMARTRR_INCLUDE_PRODUCT_SNIPPET = wrapSmartrrSnippet(
  `
  {% form 'product', product, class:form_classes, novalidate: 'novalidate', data-product-form: '', data-smartrr-form-id: product.id %}
  {% if product.available %} {% render 'smartrr-product' %} {% endif %}
  `,
  DelimiterNames.DEFAULT
);
